// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  sayId: __t.u64().primaryKey().name("say_id"),
  droidId: __t.u64().name("droid_id"),
  worldId: __t.u64().name("world_id"),
  x: __t.f32(),
  z: __t.f32(),
  kind: __t.string(),
  text: __t.string(),
  at: __t.timestamp(),
});
